import React from "react";
import { Bar, Bars, Pill } from "./VoicePillTeaser.styles";

const BAR_HEIGHTS = ["0.375rem", "0.875rem", "0.5625rem", "1rem", "0.4375rem"] as const;

/** A disabled preview of the voice control, shown until voice commands exist. */
// PENDING: VOICE-PILL
export const VoicePillTeaser: React.FC<{ label: string }> = ({ label }) => (
  <Pill aria-disabled="true" data-testid="voice-pill-teaser">
    <Bars aria-hidden="true">
      {BAR_HEIGHTS.map((height, index) => (
        <Bar key={index} $height={height} $index={index} />
      ))}
    </Bars>
    {label}
  </Pill>
);

export default VoicePillTeaser;
